import { connect } from 'react-redux';
import {
  getDailyLogReports,
  getDailyLogFranchise, 
  getCustomerList, 
  getCSReport, 
  getPdfReport,  
  getRevenueReport, 
  getReportTypeList,
  getReportZipCodeList,
  getRevenueReportById,
  getRevenueReportFranchise,
  getCustomerComplaintsFranchise,
  getCustomerComplaintsReport,
  getInvoiceReconciliationReport,
  getCustomerComplaintsReportById,
  getCommercialSalesReports,
  getCommercialSalesReportsDetails,
  getCommercialSalesFranchise,
  getCustomerPriceIncreaseReport,
  postCustomerPriceIncreaseReport,
  getCustomerPriceIncreaseReportUserRoles,
  getCustomerPriceIncreaseReportFranchises,
  getCustomerPriceIncreaseReportById,
  getFranchise, 
  getCancellationReport,
  getCancellationSummaryReport,
  getRoyaltyReport,
  getRoyaltyReportCSV,
  getLeadReport,
  getSignupReport,
  getLeadReportCSV,
  getProposalReportCSV,
  getSignupReportCSV,
  getChannelsCatalog,
  getCouponCodeReport,
  getCouponCodeReportCSV,
  getAllQuote,
  getSignupCommercialReport,
  getSignupCommercialReportCSV,
  getCancellationReportCSV,
} from '../../../../Action';
import ReportList from "../../ReportList/Component/ReportList";

const mapStateToProps = (state) => {
  const {
    franchiseList,
    dailyReports,
    errors
  } = state.DailyLogReports;

  const {
    CustomerStatementReport,
    ReportPdf,
    RevenueReport,
    CustomerComplaintsReport,
    InvoiceReconciliationReport,
    Setting,
    CommercialSalesReport,
    CustomerPriceIncreaseReport,
    CancellationReport,
    CancellationSummaryReport,
    RoyaltyReport,
    ResidentialLeadReport,
    ResidentialSignupReport,
    CommercialSignupReport,
    Channels,
    CouponCodeReport,
    CommercialProposal,
  } = state;

  return {
    franchiseList,
    dailyReports,
    errors,
    CustomerStatementReport,
    ReportPdf,
    RevenueReport,
    CustomerComplaintsReport,
    InvoiceReconciliationReport,
    Setting,
    CommercialSalesReport,
    CustomerPriceIncreaseReport,
    CancellationReport,
    CancellationSummaryReport,
    RoyaltyReport,
    ResidentialLeadReport,
    ResidentialSignupReport,
    CommercialSignupReport,
    Channels,
    CouponCodeReport,
    CommercialProposal,
  }
}
const actionCreators = {
  getDailyLogFranchise,
  getDailyLogReports,
  getCustomerList,
  getCSReport,
  getPdfReport,
  getRevenueReport,
  getReportTypeList,
  getReportZipCodeList,
  getRevenueReportById,
  getRevenueReportFranchise,
  getCustomerComplaintsFranchise,
  getCustomerComplaintsReport,
  getInvoiceReconciliationReport,
  getCustomerComplaintsReportById,
  getCommercialSalesReportsDetails,
  getCommercialSalesReports,
  getCommercialSalesFranchise,
  getCustomerPriceIncreaseReport,
  postCustomerPriceIncreaseReport,
  getCustomerPriceIncreaseReportUserRoles,
  getCustomerPriceIncreaseReportFranchises,
  getCustomerPriceIncreaseReportById,
  getFranchise,
  getCancellationReport,
  getCancellationSummaryReport,
  getRoyaltyReport,
  getRoyaltyReportCSV,
  getLeadReport,
  getSignupReport,
  getLeadReportCSV,
  getSignupReportCSV,
  getProposalReportCSV,
  getChannelsCatalog,
  getCouponCodeReport,
  getCouponCodeReportCSV,
  getAllQuote,
  getSignupCommercialReport,
  getSignupCommercialReportCSV,
  getCancellationReportCSV
}
export default (connect(mapStateToProps, actionCreators)(ReportList));